export default __webpack_public_path__ + "static/Jan-c0a02bad7013a245d92b4717c1685fd2.jpg";